module.exports = {"text":"Špatná routa","button":"Zpět"}